import { Theme } from "@mui/material/styles";

export default function Typography(theme: Theme) {
  return {
    MuiTypography: {
      styleOverrides: {
        h3: {
          fontWeight: 700,
          color: theme.palette.text.primary,

          // desktop
          fontSize: "36px",

          // tablet
          [theme.breakpoints.down("md")]: {
            fontSize: "30px",
          },

          // mobile
          [theme.breakpoints.down("sm")]: {
            fontSize: "24px",
            lineHeight: 1.3,
          },
        },

        h6: {
          fontWeight: 700,
          color: theme.palette.text.primary,
          fontSize: "20px",

          [theme.breakpoints.down("sm")]: {
            fontSize: "18px",
          },
        },

        caption: {
          fontWeight: 700,
          fontSize: "12px",
          color: theme.palette.text.primary,
        },

        paragraph: {
          marginBottom: theme.spacing(2),
        },

        gutterBottom: {
          marginBottom: theme.spacing(1),
        },
      },
    },
  };
}
